import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsule61 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_61: TIdToPageConfigMap = {
  [PageIdStylioCapsule61.SUBSCRIPTIONS_CAPSULE_61]: {
    id: PageIdStylioCapsule61.SUBSCRIPTIONS_CAPSULE_61,
  },
  [PageIdStylioCapsule61.SUB_UPSELL_CAPSULE_61]: {
    id: PageIdStylioCapsule61.SUB_UPSELL_CAPSULE_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule61.FACE_STYLING_PDF_UPSELL_CAPSULE_61]: {
    id: PageIdStylioCapsule61.FACE_STYLING_PDF_UPSELL_CAPSULE_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule61.PROPORTIONS_PDF_UPSELL_CAPSULE_61]: {
    id: PageIdStylioCapsule61.PROPORTIONS_PDF_UPSELL_CAPSULE_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule61.DOWNLOAD_CAPSULE_61]: {
    id: PageIdStylioCapsule61.DOWNLOAD_CAPSULE_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
